import ninegrid from "../index.js";
import { ngEditableEx } from "./_ngCell.js";
import { ngElement } from './_ngElements.js';

import { trace } from '@nopeer';

class ngCombo extends ngEditableEx
{
	#EXPAND_ROWS = 10;

	#target;
	#panel;
	#dataSource;
	#rows;
	#code;
	#value;
	#items;
	
	constructor() {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {
		
		this.multi			= this.getAttribute('multi') == "true";
		this.multiSeparator	= this.getAttribute("multi-separator") || ",";
		
		this.#rows			= this.getAttribute('rows') || 5;
		this.#code			= this.getAttribute("code") || "code";
		this.#value			= this.getAttribute("codename") || "codename";
		this.#items			= (this.getAttribute('items') || this.#value || "").split(",");

		this.#items.unshift("CHK");
		
		var datalist = this.querySelector("datalist");

		if (datalist) {
			this.#dataSource = [];
			
			datalist.querySelectorAll("option").forEach(option => {
				const k = option.getAttribute(this.#code);
				const v = option.getAttribute(this.#value);
				//trace.log(this.#code, this.#value, k, v)

				if (k && v) {
					this.#dataSource.push({
						[this.#code] : k,
						[this.#value] : v,
					});
				}
			});
		}

		//trace.log(this.#dataSource)
		
		
		/**
		 * 
		if (cell && cell.dataset && dataSource && !cell.dataset.expr) {
			
			cell.dataset.expr = `ninegrid.binarySearchValue(${dataSource}, "${this.#code}", (data["${cell.dataset.bind}"] || '').split("${this.multiSeparator}"), "${this.#value}")`;
		} */
		
		this.shadowRoot.innerHTML = `
			<button class="btn1" type="button" data-bs-toggle="dropdown" aria-expanded="false" tabindex="-1"></button>
			<button class="btn2" tabindex="-1"></button>
		`;
		
		super.connectedCallback();

		
		/**
		 * datalist가 정의되었으면 ninegrid 에서 data-expr을 셋팅하고
		 * 아니면 아래코드를 data-expr을 셋팅한다.
		 */
		const cell = this.closest("th,td");
		const dataSource = this.getAttribute('data-source');
		
		if (dataSource && this.owner && this.owner.exprFunction) {

			if (this.owner[dataSource]) {
				this.#dataSource = this.owner[dataSource];
			}
			else {
				this.#dataSource = this.owner.exprFunction(dataSource).call(this, this.owner.data.get(this.cell.dataset.row), this.cell.dataset.row);
			}
		}
		
		if (cell && cell.dataset && this.#dataSource && !cell.dataset.expr) {
			cell.dataset.expr = "comboExpr()";
		}

		this.#init();
		if (!this.#panel) {
			//this.owner.shadowRoot.querySelector("ng-combo-panel");
		}
		
		/**
		if (this.#dataSource) {
			if (this.#dataSource.length > 0) {
				var oData = this.#dataSource[0];

				if (oData instanceof Object == false) {
					this.#code = "code";
					this.#value = "code";
					this.#items = ["code"];
					
					var arr = [];
					this.#dataSource.forEach(v => { arr.push({"code": v}); } );
					this.#dataSource = arr;
				}
			}
		} */

		this.#target	= this.shadowRoot.querySelector(".btn1");
		
		var col = this.closest("th,td").dataset.col;
		var row = this.closest("tr").sectionRowIndex;
		
		$(this.cell).on("keydown", e => { if (e.code == "Enter") $(this.#target).trigger("click"); });
		$("button", this.shadowRoot).on("click", e => { (this.#panel.row == row && this.#panel.col == col) ? this.#close(e) : this.#open(e); });
	};
	
	dataRefresh = (v) => {

		if (this.#dataSource) {
			this.#isValid() ? ninegrid.j.querySelectorAll(this).removeClass("invalid") : ninegrid.j.querySelectorAll(this).addClass("invalid");
		}
		
		this.#target.innerHTML = this.getDisplayText() || "Select";
		
		if (!v) this.reset();
	};
	
	get dataSource() {
		return this.#dataSource;
	};
	
	#isValid = () => {
		
		if (ninegrid.isNull(this.value)) return true;
		
		var list = (this.multi) ? this.value.split(this.multiSeparator) : [this.value];
		
		for (var v of list) {
			var idx = this.#dataSource.findIndex(m => { return v == m[this.#code]; });
			if (idx < 0) return false;
		}
		
		return true;
	};
	
	
	#init = () => {
		if (!this.owner) return;
		
		this.#panel	= this.owner.shadowRoot.querySelector("ng-combo-panel");

		if (this.owner.shadowRoot.querySelectorAll('ng-combo-panel').length > 1) throw "too many ng-combo-panel";
		//if (!this.#panel) throw 'ng-combo-panel is null';
		
		/**
		var dataSource = this.getAttribute('dataSource');
		if (dataSource && this.owner[dataSource]) {
			this.#dataSource = this.owner[dataSource];
		} */
		var dataSource = this.getAttribute('data-source');
		if (dataSource && this.owner && this.owner.exprFunction) {
			//this.#dataSource = this.owner.exprFunction(dataSource).call(this, this.owner.data.get(this.cell.dataset.row), this.cell.dataset.row);
		}
	};

	#open = (e) => {
		/**
		var dataSource = this.getAttribute('dataSource');
		if (dataSource && this.owner[dataSource]) {
			this.#dataSource = this.owner[dataSource];
		} */
		
		console.log(this.#dataSource);

		if (!this.#dataSource) return;
		
		console.log(this.#dataSource);
		
		this.#panel.col = this.cell.dataset.col;
		this.#panel.row = this.cell.closest("tr").sectionRowIndex;
		
		this.#dataSource.length > this.#EXPAND_ROWS ? ninegrid.j.querySelectorAll(this.#panel).addClass("expand") : ninegrid.j.querySelectorAll(this.#panel).removeClass("expand");
		this.multi ? ninegrid.j.querySelectorAll(this.#panel).addClass("multi") : ninegrid.j.querySelectorAll(this.#panel).removeClass("multi");

		this.#panel.refresh(this, this.#dataSource, this.#code, this.#items);
		
		//var w = $(this.#panel).width();
		
		var l = $(".btn1", this.shadowRoot).offset().left - $(this.owner).offset().left;
		if (l + $(this.#panel).width() > $(this.owner).width()) l = $(".btn2", this.shadowRoot).offset().left - $(this.owner).offset().left - $(this.#panel).width() + 8;
		if (l < 0) l = 0;
		
		var h = Math.min(this.#dataSource.length, this.#rows) * 26;

		
		if (this.multi) {
			if (ninegrid.j.querySelectorAll(this.#panel).hasClass("expand")) {
				h += 12; //위아래 padding
				h += 3; //margin
				h += 24; // input box
			}
			h += 2;
			h += 3;
			
			h += 25; // bottom
		}
		else {
			if (ninegrid.j.querySelectorAll(this.#panel).hasClass("expand")) {
				h += 12; //위아래 padding
				h += 3; //margin
				h += 24; // input box
			}
			
			h += 3;
		}

		
		var t =  $(".btn1", this.shadowRoot).offset().top +  $(".btn1", this.shadowRoot).height() - $(this.owner).offset().top + 3;
		if (t + h > $(this.owner).height()) {
			t -= h +  $(".btn1", this.shadowRoot).height() + 6;
		}

		var template = this.getAttribute("template");
		if (template) {
			console.error("logic error !!!!")
		}
		/**
		if (template) {
			h += 26;
		} */

		$(this.#panel).css({
			"left"		: l,
			"top"		: t,
			"height"	: h,
			"min-height": h,
		}).show();
		
		if (ninegrid.j.querySelectorAll(this.#panel).hasClass("expand")) {
			$("div", this.#panel).eq(0).find("input").focus().val("");
		}
	};
	
	#close = (e) => {
		
		if (e.target.closest("ng-combo-panel")) return;
		
		this.#panel.row = this.#panel.col = -1;
		
		$(this.#panel).hide();
	};
	
	#expr = () => {
		return "a";
	};
}

class ngComboPanel extends ngElement
{
	#owner;
	#parent;
	#code;
	#timer;
	#items;
	
	constructor() {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {
		
		this.#owner = this.getRootNode().host.closest("nine-grid");
		
		const cssPath = this.#owner.getAttribute("css-path") || "";
		
		this.shadowRoot.innerHTML = `
			<div class="head">
				<input type="text">
			</div>
			<nine-grid class="simple combo" css-path="${cssPath}" select-type="row" auto-fit-col="true">
				<table>
					<colgroup>
						<col width="0" fixed="left" />
						<col width="0" />
						<col width="0" />
						<col width="0" />
						<col width="0" />
						<col width="0" />
						<col width="0" />
						<col width="0" />
						<col width="0" />
						<col width="0" />
						<col width="0" />
					</colgroup>
					<tbody>
						<tr style="height: 24px;">
							<td data-bind="CHK">
								<ng-checkbox update-row-state="false" selected-border-color="white" />
							</td>
							<td data-bind="tmp1" />
							<td data-bind="tmp2" />
							<td data-bind="tmp3" />
							<td data-bind="tmp4" />
							<td data-bind="tmp5" />
							<td data-bind="tmp6" />
							<td data-bind="tmp7" />
							<td data-bind="tmp8" />
							<td data-bind="tmp9" />
							<td data-bind="tmp10" />
						</tr>
					</tbody>
				</table>
			</nine-grid>
			<div>
				<input id="chkAll" type="checkbox" checked><label for="chkAll">Select All</label>
				<button id="btnOk">OK</button>
			</div>
		`;


		super.connectedCallback();

		this.#init();
	};
	
	#init = () => {
		$("input[type=checkbox]",	this.shadowRoot).on("change",	this.#onSelectAll);
		$("input[type=text]",		this.shadowRoot).on("input",	this.#onInput);
		$("button#btnOk",			this.shadowRoot).on("click",	this.#onOk);
	};
	
	#onKeyDown = e => {
		if (["TH","TD"].includes(e.target.tagName)) {
			if (["Enter"].includes(e.code)) {
				this.#parent.multi ? this.#onOk(e) : this.#onClick(e);
			}
		}
	};
	
	#onSelectAll = (e) => {
		var grd = this.shadowRoot.querySelector("nine-grid");
		var idx = (grd.fields.indexOf("CHK"));

		grd.data.getValidData().map(m => { m.v[idx] = $(e.target).prop("checked") ? "Y" : "N"; });
		
		grd.refreshData();
	};
	
	#onOk = (e) => {
		
		var grd = this.shadowRoot.querySelector("nine-grid");
		var data = grd.data.getValidData();
		
		const CHK_IDX = grd.fields.indexOf("CHK");
		const KEY_IDX = grd.fields.indexOf(this.#code);
		
		var a = [];
		data.forEach(o => {
			if (o.v[CHK_IDX] == "Y") {
				a.push(o.v[KEY_IDX]);
			}
		});
		
		var td = e.target.closest("th,td");
		$(td).blur();
		
		
		this.#parent.value = a.join(this.#parent.multiSeparator);
		
		$(this).hide();
		
		this.#parent.getRootNode().host.cell.currentCell = this.#parent.closest("th,td");
	};
	
	
	
	#onClick = e => {

		/**
		 * 아래 코드시 체크박스 체크 안됨, 일단 checkbox면 스킵한다.
		 */
		if (e.target.tagName != "NG-CHECKBOX") {
			e.preventDefault();
			e.stopPropagation();
		}
		
		
		if (this.#parent.multi) return;
		
		var grd = this.shadowRoot.querySelector("nine-grid");
		
		var td = e.target.closest("th,td");
		$(td).blur();
		
		this.#parent.value = grd.data.get(td.dataset.row)[this.#code];
		
		this.row = this.col = -1;
		
		$(this).hide();
		
		this.#parent.getRootNode().host.cell.currentCell = this.#parent.closest("th,td");
	};
	
	#parent_onMouseDown = e => {
		e.preventDefault();
		e.stopPropagation();
		$(this).hide();
	};
	
	#onInput = e => {
		var grd = this.shadowRoot.querySelector("nine-grid");

		ninegrid.j.querySelectorAll(grd).addClass("loading");

		var data = grd.data.getValidDataNF();
		data.map(m => { m.__ng.filtered = false; });
		
		var v = $(e.target).val().toLowerCase();
		
		data.filter(m => {
			for (var item of this.#items) {
				if (item == "CHK") continue;
				const IDX = grd.fields.indexOf(item);
				if ((String(m.v[IDX]) || '').toLowerCase().indexOf(v) >= 0) return false;
			}
			return true;
		}).map(item => { item.__ng.filtered = true; });
		
		grd.data.resetRecords();
		
		if (grd.data.count() == 0) ninegrid.j.querySelectorAll(grd).removeClass("loading");
		
		if (this.#timer) {
			clearTimeout(this.#timer);
			this.#timer = null;
		}
		this.#timer = setTimeout(() => {
			grd.dataManager.viewRecords.reset();
		}, 200)
	};

	refresh = (parent, data, code, items) => {
		
		var grd = this.shadowRoot.querySelector("nine-grid");
		

		$(this.shadowRoot).find("input[type=text]").val("");
		$("input[type=checkbox]",	this).prop('checked',true);
		
		this.#items = items;
		
		//$(this.getRootNode().host).off("mousedown", this.#parent_onMouseDown);
		//$(this.getRootNode().host).on("mousedown", this.#parent_onMouseDown);
		$(".ng-table tbody", grd.body).off("click", "th,td", this.#onClick);
		$(".ng-table tbody", grd.body).on("click", "th,td", this.#onClick);
		
		this.#parent = parent;
		this.#code = code;

		
		$('th,td', grd.template).each((i,el) => { $(el).hide(); });
		$('thead th', grd).each((i,el) => { /**$(el).css({"width":0,"min-width":0,});*/ $(el).hide(); });
		
		items.forEach((item,i) => {
			$(`[data-col=${i}]`, grd.template).each((j,el) => { el.dataset.bind = item; $(el).show(); });
			$(`[data-col=${i}]`, grd.body).each((j,el) => { el.dataset.bind = item; $(el).show(); });
			//$(`thead th[data-col=${i}]`, grd).each((i,el) => { $(el).show(); });
		});
		
		const arr = ["CHK"];
		if (data.length > 0) {
			for (const v in data[0]) {
				arr.push(v);
			}
		}
		
		grd.fields.add(arr);
		
		grd.data.set(data);
	
		this.#resize(items);
		
		$(".ng-container-left", grd.body).css({
			"width"		: this.#parent.multi ? 30 : 0,
			"min-width"	: this.#parent.multi ? 30 : 0,
		});
		
		if (this.#parent.multi) {
			var arrKey = this.#parent.value.split(this.#parent.multiSeparator);
			
			const CHK_IDX = grd.fields.indexOf("CHK");
			const KEY_IDX = grd.fields.indexOf(this.#code);
			grd.data.getValidData().forEach(m => {
				m.v[CHK_IDX] = arrKey.includes(m.v[KEY_IDX]) ? "Y" : "N";
			});
			
			grd.row.at = 0;
		}
		else {
			var colIndex = grd.fields.indexOf(this.#code);
			grd.row.at = grd.data.getValidData().findIndex(m => { return this.#parent.value == m.v[colIndex] });
		}

		setTimeout(() => {
			$(`tbody.bindable tr[data-row="${grd.row.at}"]`, grd.shadowRoot).find("td").eq(0).focus();
		});
		
		$(".ng-table tbody", grd.body).off("keydown",	"th,td",	this.#onKeyDown);
		$(".ng-table tbody", grd.body).on("keydown",	"th,td",	this.#onKeyDown);
	};
	
	
	#resize = () => {
		var grd = this.shadowRoot.querySelector("nine-grid");
		
		$("col", grd.body).each((i,el) => { el.setAttribute("width", "0"); });
		$("th", grd.body).each((i,el) => { $(el).html(""); });
		/**
		$("thead", grd.body).css({
			"visibility"	: "collapse"
			//"display" : "none"		// rowDetail 화면에서 combo 클릭시 무한루프
		}); */

		this.#items.forEach((item,col) => {
			grd.setColumnWidthFit(col, 30, false);
		});
		
		var template = this.#parent.getAttribute("template");
		if (template) {
			console.error("logic error !!!!")
		}
		/**
		var template = this.#parent.getAttribute("template");
		if (template) {

			$("col", template).each((i,el) => {
				console.log(el);
				$(".ng-container-body col", grd.body).eq(i).attr("width", $(el).attr("width"));
			});
			
			$("th", template).each((i,el) => {
				$(".ng-container-body th", grd.body).not(".col-indicator").eq(i).html($(el).html());
			});
		}
		*/
		
		var w = 16 + (ninegrid.j.querySelectorAll(this).hasClass("expand") ? 0 : 0) + 20;

		if (ninegrid.j.querySelectorAll(this).hasClass("multi")) {
			$("col", grd.body).each((i,el) => { w += parseInt(el.getAttribute("width")); });
		}
		else {
			$(".ng-container-body col", grd.body).each((i,el) => { w += parseInt(el.getAttribute("width")); });
		}

		if (w < $(this.#parent).width()) w = $(this.#parent).width() - 8;
		if (w > $(this.#parent.closest("nine-grid")).width()) w = $(this.#parent.closest("nine-grid")).width();

		$(this).css({
			"width": w,
			"min-width": w,
		});

		$(".ng-container-body .ng-table", grd.body).css({"left": 0});
	}
}

if (!customElements.get('ng-combo')) {
	customElements.define("ng-combo", ngCombo);
}

if (!customElements.get('ng-combo-panel')) {
	customElements.define("ng-combo-panel", ngComboPanel);
}